import { TooltipWrapper } from './TooltipWrapper';

interface TooltipIconProps {
  description: string;
}

export function TooltipIcon({ description }: TooltipIconProps) {
  return (
    <TooltipWrapper content={description}>
      <i className="las la-question-circle" />
    </TooltipWrapper>
  );
}
